import React from "react";
import Header from "./components/header";
import Loader from "storybookComponents/Loader";
import Button from "storybookComponents/Button";
import { withStyles, Typography, Box, InputBase } from "@material-ui/core";
import Modal from "components/Modal";
import cancelRsvp from "relay/event/mutations/cancelRsvp";
import confirmRsvp from "relay/event/mutations/confirmRsvp";
import markAttended from "relay/event/mutations/markAttended";
import environment from "environments/environment";
import { getErrorMessage, checkUncatchableError } from "environments/uncatchableErrorStore";
import { Empty } from "./components/emptyView";
import { compare } from "content/utils/commonParsing";
import StyledTable from "components/StyledTable";
import { getColumns, buttonText } from "./common";
import Icon from "storybookComponents/Icon";
import FilterBar from "./components/filterbar";
import { getAttendees } from "relay/event";
import moment from "moment";

const styles = () => ({
  rootContainer: {
    background: "#f9f9f9",
  },
  closeCancelModal: {
    color: "#333",
    borderRadius: 0,
    fontSize: 14,
    fontWeight: 600,
    textTransform: "none",
  },
  cancelButton: {
    color: "#333",
    borderRadius: 0,
    borderColor: "#999",
    fontSize: 14,
    fontWeight: 600,
  },
  description: {
    fontSize: 16,
    fontWeight: 400,
  },
  cancelFieldLabel: {
    marginBottom: 4,
    marginTop: 24,
  },
  cancelField: {
    borderRadius: "none",
    border: "1px solid #dadada",
    padding: 12,
  },
  backgroundClass: {
    background: "linear-gradient(0deg, rgba(38, 187, 237, 0.1), rgba(38, 187, 237, 0.1)), #FFFFFF",
  },
  loader: {
    height: "calc(100vh - 165px)",
    position: "relative",
  },
  root: {
    marginTop: "12px",
    height: "calc(100vh - 156px)",
    marginBottom: "20px",
    overflowY: "auto",
    padding: "0px 20px",
  },
  rootCustomHeight: {
    height: "calc(100vh - 206px)",
  },
  tableHeader: {
    fontFamily: "Open Sans",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "20px",
    color: "#333333",
    background: "white",
    zIndex: 1,
  },
  searchContainer: {
    marginTop: 8,
  },
  simpleClass: {
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 120,
  },
  marginRightIcon: {
    marginRight: 10,
  },
  emptyTableView: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "94%",
    background: "white",
    border: "1px solid #dadada",
  },
  divStyle: {
    textAlignLast: "center",
  },
  fullNameColor: {
    color: "#4F6FAE",
    textTransform: "capitalize",
    cursor: "pointer",
    "&:hover": {
      color: "#26bbed",
    },
  },
  tableCell: {
    padding: "16px 32px 16px 16px !important",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "right",
    width: "100%",
    minWidth: 120,
  },
  select_root: {
    fontSize: 12,
    minWidth: 150,
    height: 18,
  },
});

const Attendees = ({
  setOpenAttendeesList,
  classes,
  eventRSVP,
  isNotificationsBarVisible,
  showNotification,
  eventType,
  timezoneString,
}) => {
  const [attendees, setAttendees] = React.useState([]);
  const [attendeesCount, setAttendeesCount] = React.useState({
    allAttended: 0,
    allRsvp: 0,
  });
  const [loading, setLoading] = React.useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [cancelReason, setCancelReason] = React.useState();
  const [attendeesToCancel, setAttendeesToCance] = React.useState();
  const [event, setEvent] = React.useState(eventRSVP);
  const [CSVData, setCSVData] = React.useState([]);
  const [rows, setRows] = React.useState([]);

  const handleChangeEvent = (event, emptyView) => {
    if (emptyView) {
      setEvent({});
      setCSVData([]);
      setAttendees([]);
      setAttendeesCount({
        allAttended: 0,
        allRsvp: 0,
      });
    } else {
      setEvent(event);
      loadAttendees(event.id);
    }
  };

  const handleCancelClickedCallback = (attendees, text) => {
    if (text == "Cancel RSVP") {
      setAttendeesToCance(attendees);
      setCancelReason(
        `We are Sorry! Due to unforeseen circumstances we had to make the hard decision. We understand it is tough to say but unfortunately, we have cancelled your RSVP. We regret the complete inconvenience.\n\nWe will keep you updated on further steps towards this event.`
      );
      setModalOpen(true);
    } else {
      confirmRSVP(attendees);
    }
  };

  const confirmRSVP = async (attendees) => {
    try {
      let response = await confirmRsvp(environment, {
        eventId: event.id,
        id: attendees.id,
      });

      if (response && response.confirmRsvp) {
        loadAttendees(event.id);
        showNotification(`You have successfully confirmed ${attendees.fullName}’s RSVP.`);
      } else {
        const uncatchableError = getErrorMessage(checkUncatchableError("confirmRsvpMutation"));
        showNotification(uncatchableError || `Something went wrong`, "error");
      }
    } catch (err) {
      const uncatchableError = getErrorMessage(checkUncatchableError("confirmRsvpMutation"));
      showNotification(uncatchableError || `Something went wrong`, "error");
    }
  };

  const cancelAttendeeesHandler = async (attendee) => {
    try {
      let response = await cancelRsvp(environment, {
        eventId: event.id,
        id: attendee.id,
        //reason: cancelReason
      });
      if (response && response.cancelRsvp) {
        loadAttendees(event.id);
        showNotification(`You have successfully canceled ${attendee.fullName}’s RSVP.`);
      } else {
        const uncatchableError = getErrorMessage(checkUncatchableError("cancelRsvpMutation"));
        showNotification(uncatchableError || `Something went wrong`, "error");
      }
    } catch (err) {
      const uncatchableError = getErrorMessage(checkUncatchableError("cancelRsvpMutation"));
      showNotification(uncatchableError || `Something went wrong`, "error");
    }
  };

  const toggleAttendees = async (attendee) => {
    try {
      let response = await markAttended(environment, {
        eventId: event.id,
        id: attendee.id,
      });
      console.log("response", response)
      if (response && response.markAttended) {
        loadAttendees(event.id);
        showNotification(
          `You have successfully mark  ${attendee.fullName} ${attendee.attended ? "unattended" : "attended"
          }.`
        );
      } else {
        const uncatchableError = getErrorMessage(checkUncatchableError("markAttendedMutation"));
        showNotification(uncatchableError || `Something went wrong`, "error");
      }
    } catch (err) {
      const uncatchableError = getErrorMessage(checkUncatchableError("markAttendedMutation"));
      showNotification(uncatchableError || `Something went wrong`, "error");
    }
  };

  React.useEffect(() => {
    loadAttendees(event.id);
  }, []);

  const getAttendeesOfEvent = async (eventId) => {
    try {
      const response = await getAttendees(eventId);
      if (response.attendees) {
        const attendees = response.attendees.edges;
        if (attendees) {
          return attendees;
        } else {
          return null;
        }
      }
    } catch (error) {
      return null;
    }
  };

  const loadAttendees = async (id) => {
    try {
      setLoading(true);
      const response = await getAttendeesOfEvent(id);
      if (response.length > 0) {
        let data = response.map((item) => item.node);
        setAttendees(data);
        let allAttended = 0;
        let allRsvp = 0;

        for (let i = 0; i < data.length; i++) {
          if (data[i].attended) {
            allAttended = allAttended + 1;
          }
          if (data[i].status == "rsvped") {
            allRsvp = allRsvp + 1;
          }
        }
        createRows(data);
        setAttendeesCount({
          allAttended,
          allRsvp,
        });
      } else {
        setAttendees([]);
        setAttendeesCount({
          allAttended: 0,
          allRsvp: 0,
        });
        setCSVData([]);
      }
      setLoading(false);
    } catch (err) {
      console.log("err", err);
      setLoading(false);
    }
  };

  const createRows = (data) => {
    setRows(getRows(data));
    setCSVData(data);
  };

  const handleSort = (field, order) => {
    let sortedData = attendees.slice().sort((a, b) => compare(a[field], b[field], !order));
    createRows(sortedData);
  };

  const handleOpenUrl = (item) => {
    window.open(item.crmUrl, "_blank");
  };

  const handleSearch = (key, search) => {
    try {
      if ((key === "status" && search == "All") || (key === "isResident" && search == "all")) {
        createRows(attendees);
        return;
      }
      let filterData;
      if (key === "isResident") {
        if (search == "prospect") {
          filterData = attendees.filter((e) => !e.isResident);
        } else {
          filterData = attendees.filter((e) => e.isResident);
        }
      } else {
        filterData = attendees.filter((e) => {
          const value = e[key] ? e[key].toString().toLowerCase() : "--";
          if (value.includes(search.toLowerCase())) {
            return e;
          }
        });
      }
      createRows(filterData);
    } catch (err) {
      console.log("err", err);
    }
  };

  const onStatusFilterChange = (key, evt) => {
    handleSearch(key, evt.id);
  };

  const getRows = (d) => {
    return d.map((data) => {
      const status = !event.upcoming && data.attended ? "Attended" : data.status;
      const details = buttonText[status];
      const color = details.color;
      const text = event.upcoming ? details.upcomingButtonText : details.pastButtonText;
      return {
        fullName: (
          <Typography className={classes.fullNameColor} onClick={handleOpenUrl.bind(this, data)}>
            {data.fullName}
          </Typography>
        ),
        isResident: <Typography>{data.isResident ? "Resident" : "Prospect"}</Typography>,
        email: <Typography> {data.email || "--"}</Typography>,
        phone: <Typography>{data.phone || "--"}</Typography>,
        additionalGuests: (
          <Typography>{data.additionalGuests > 0 ? data.additionalGuests : "--"}</Typography>
        ),
        status: (
          <Typography>
            <div
              style={{
                color: color,
                fontWeight: "bold",
              }}
            >
              {details.status}
            </div>
          </Typography>
        ),
        action: (
          <div className={classes.buttonContainer}>
            {text && (
              <Button
                state={"active"}
                negative={event.upcoming && text == "Cancel RSVP" ? true : false}
                className={classes.simpleClass}
                variant="secondary"
                onClick={
                  event.upcoming
                    ? handleCancelClickedCallback.bind(this, data, text)
                    : toggleAttendees.bind(this, data)
                }
              >
                {!event.upcoming && (
                  <Icon
                    size="sm"
                    className={classes.marginRightIcon}
                    type={data.attended ? "icon-e-remove" : "icon-check-single"}
                  />
                )}
                {text}
              </Button>
            )}
          </div>
        ),
      };
    });
  };

  const columns = getColumns(classes, handleSearch, onStatusFilterChange);

  return (
    <div className={classes.rootContainer}>
      <Modal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        maxWidth="sm"
        title="Cancel RSVP"
        actionChildren={
          <>
            <Button
              disbaled={!cancelReason}
              variant="tertiary"
              onClick={() => setModalOpen(false)}
              className={classes.closeCancelModal}
            >
              Do Not Cancel
            </Button>
            <Button
              disabled={!cancelReason}
              variant="secondary"
              negative
              className={classes.cancelButton}
              onClick={() => {
                setModalOpen(false);
                cancelAttendeeesHandler(attendeesToCancel, cancelReason);
              }}
            >
              Yes, Cancel RSVP
            </Button>
          </>
        }
      >
        <Typography className={classes.description}>
          Are you sure, you want to cancel the{" "}
          <strong>{attendeesToCancel && attendeesToCancel.fullName} ?</strong>{" "}
        </Typography>

        {/* <Box className={classes.cancelFieldLabel} color="#999" fontSize={12}>Message</Box> */}
        {/* <InputBase
          multiline
          rows={6}
          value={cancelReason}
          onChange={(event) => setCancelReason(event.target.value)}
          variant="outlined"
          fullWidth
          className={classes.cancelField}
        /> */}
      </Modal>
      <Header setOpenAttendeesList={setOpenAttendeesList} />
      <div className={`${classes.root} ${isNotificationsBarVisible && classes.rootCustomHeight}`}>
        <FilterBar
          eventType={eventType}
          dateRange={{
            startAt: moment(eventRSVP.startAt),
            endAt: moment(eventRSVP.endAt),
            label: "Custom Range",
          }}
          id={event.id}
          timezoneString={timezoneString}
          handleChangeEventCallback={handleChangeEvent}
          setShowFilter={setShowFilter}
          showFilter={showFilter}
          upcoming={event.upcoming}
          attendeesCount={attendeesCount}
          CSVData={CSVData}
        />
        {loading ? (
          <div className={classes.loader}>
            <Loader />
          </div>
        ) : attendees.length == 0 ? (
          <Empty upcoming={event?.upcoming} emptyView={!event.id} classes={classes} />
        ) : (
          <StyledTable
            columns={columns}
            rows={rows}
            sortHandler={handleSort}
            showFilter={showFilter}
          />
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(Attendees);
